import type { Discipline } from '@/hooks/useDashboardChannel'

// "Ride" is a cycling-specific word -- when "All" is selected the catalog
// is a mix of rides/runs/walks, so the copy needs a discipline-aware noun
// rather than defaulting to "ride" everywhere.
const NOUNS: Record<Discipline, { singular: string; plural: string; pluralCapitalized: string }> = {
  all: { singular: 'workout', plural: 'workouts', pluralCapitalized: 'Workouts' },
  cycling: { singular: 'ride', plural: 'rides', pluralCapitalized: 'Rides' },
  running: { singular: 'run', plural: 'runs', pluralCapitalized: 'Runs' },
  walking: { singular: 'walk', plural: 'walks', pluralCapitalized: 'Walks' },
  pilates: { singular: 'pilates class', plural: 'pilates classes', pluralCapitalized: 'Pilates Classes' },
  yoga: { singular: 'yoga class', plural: 'yoga classes', pluralCapitalized: 'Yoga Classes' },
  stretching: { singular: 'stretching class', plural: 'stretching classes', pluralCapitalized: 'Stretching Classes' },
  meditation: { singular: 'meditation session', plural: 'meditation sessions', pluralCapitalized: 'Meditation Sessions' },
  cardio: { singular: 'cardio class', plural: 'cardio classes', pluralCapitalized: 'Cardio Classes' },
  strength: { singular: 'strength class', plural: 'strength classes', pluralCapitalized: 'Strength Classes' },
}

export function workoutNouns(discipline: Discipline) {
  return NOUNS[discipline]
}
